import { Navigate, useLocation, useParams } from "react-router-dom";
import { normalizeMatchRoomCode } from "../utils/matchRoomCode";

/**
 * Canonical live session entry is `/room/:roomCode/session` (Room Experience).
 * Legacy `/match/:roomCode` deep links redirect here (query string preserved).
 */
export default function MatchToRoomSessionRedirect() {
  const { roomCode } = useParams();
  const location = useLocation();
  const code = normalizeMatchRoomCode(roomCode);

  if (!code) {
    return <Navigate to="/play" replace />;
  }

  const search = location.search || "";
  const hash = location.hash || "";
  return (
    <Navigate
      to={`/room/${encodeURIComponent(code)}/session${search}${hash}`}
      replace
    />
  );
}
